<template>
  <v-dialog
    :model-value="show"
    no-click-animation
    max-width="720"
    scrim="white"
    class="overlay-backdrop-filter"
    persistent
  >
    <v-card class="pt-4 pb-8 px-3 upgrade-card" rounded="lg">
      <div class="d-flex justify-end">
        <v-btn
          class="modal-close-btn"
          append-icon="fa-solid fa-xmark"
          flat
          rounded="pill"
          variant="text"
          size="small"
          @click="$emit('close')"
        >
          {{ $vuetify.display.xs ? "" : "Aizvērt" }}
        </v-btn>
      </div>

      <div class="scrollable-content">
        <div class="text-center my-4">
          <div class="mb-4">
            Paldies! Paroles atjaunošanas instrukcija ir nosūtīta uz Jūsu e-pastu.
          </div>
        </div>

        <div class="card-actions my-4 d-flex flex-column flex-sm-row justify-center gap-10">
          <v-btn flat class="v-btn-quiz" color="yellowActive" rounded="pill" @click="$emit('close')"> Aizvērt </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },

  emits: ["close"],
}
</script>

<style lang="sass" scoped>
.overlay-backdrop-filter
  backdrop-filter: blur(7px)
.modal-close-btn
  text-transform: none
  font-size: 15px
  font-weight: 700
</style>
